import { css } from '@emotion/react';
import styled from '@emotion/styled';

import CloseSvg from '@/assets/icons/close.svg?react';
import StarsSvg from '@/assets/icons/stars.svg?react';

export const Wrapper = styled.div`
  position: fixed;
  top: 115px;
  right: 0;
  bottom: auto;
  border-radius: 20px 0 0 20px;
  background: ${({ theme }) => theme.colors.light};
  animation: ${({ theme }) => theme.animation.widget.side.openWidget} forwards 300ms cubic-bezier(0.89, 0, 0.01, 0.99);

  ${({ theme }) => css`
    ${theme.widget.wrapper.styles}

    @media (${theme.mediaMobile}) {
      ${theme.widget.wrapper.mobile}
    }

    @media not (${theme.mediaMobile}) {
      ${theme.widget.wrapper.desktop}
    }
  `}
`;

export const Inner = styled.div<{ isTooltipOpen: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  width: auto;
  min-width: 112px;
  max-width: ${({ isTooltipOpen }) => (isTooltipOpen ? '999px' : '112px')};
  height: 74px;
  padding: 0 22px;
  overflow: hidden;
  cursor: pointer;
  transition: max-width 300ms cubic-bezier(0.89, 0, 0.01, 0.99);
`;

export const Title = styled.div`
  position: relative;
  font-size: 13px;
  text-align: center;

  strong {
    font-weight: 900;
  }
`;

export const StarsIcon = styled(StarsSvg)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: -21px;
  margin: auto;
  width: 19px;
`;

export const Tooltip = styled.p`
  position: relative;
  flex-shrink: 0;
  margin-right: 61px;
  font-size: 13px;
  font-weight: 500;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: -16px;
    bottom: 0;
    margin: auto;
    width: 0;
    height: 160%;
    border-right: 1px dashed black;
  }
`;

export const CloseIcon = styled(CloseSvg)`
  display: block;
  max-width: 8px;
`;

export const CloseBtn = styled.button<{ isFirstRender: boolean }>`
  position: absolute;
  top: -6px;
  left: -6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  opacity: 0;
  visibility: hidden;
  border: 1px solid rgb(130 130 130);
  border-radius: 50%;
  background: rgb(238 231 223 / 79%);
  animation-name: ${({ theme }) => theme.animation.widget.side.closeButton};
  animation-duration: 300ms;
  animation-timing-function: cubic-bezier(0.89, 0, 0.01, 0.99);
  animation-fill-mode: forwards;
  backdrop-filter: blur(3px);
`;
